import type { ReactNode } from 'react';
import type React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Styles from './PropertyDealLayout.module.scss';
import type { PropertyDealWithPrices } from '~/models/PropertyDeal';

type Props = DeepReadonly<{
  children: ReactNode;
  propertyDeal: PropertyDealWithPrices;
  items: React.ComponentProps<typeof Breadcrumbs>['items'];
}>;

/**
 * @for client
 * @constructor
 */
export const PropertyDealLayout: React.FC<Props> = ({
  children,
  propertyDeal,
  items
}: Props) => (
  <div>
    <div className={Styles.Header}>
      <div>
        <Breadcrumbs items={items} />
        <div className={Styles.HeaderElements}>
          <h1 className={Styles.RoomName}>
            {propertyDeal.name} {propertyDeal.roomNumber}
          </h1>
        </div>
      </div>
    </div>
    <div className={Styles.Container}>{children}</div>
  </div>
);
